import Text from '@cartwhl/ui/base/Text';

import { BLOG_ARTICLE_CDN_BASE } from './cdn';
import BlogVideo from './BlogVideo';

interface ArticleVideoProps {
  cdnKey: string;
  alt?: string;
  caption?: string;
}

export default function ArticleVideo({ cdnKey, alt, caption }: ArticleVideoProps) {
  return (
    <figure className="article-breakout my-8 px-4 lg:my-12 lg:px-0">
      <BlogVideo
        src={`${BLOG_ARTICLE_CDN_BASE}${cdnKey}`}
        className="w-full overflow-hidden rounded-2xl"
        description={alt ?? caption ?? 'Video preview'}
      />
      {caption && (
        <figcaption className="article-caption mx-auto mt-3 px-4">
          <Text
            as="span"
            variant="web/body/medium/xs"
            className="text-tertiary"
          >
            {caption}
          </Text>
        </figcaption>
      )}
    </figure>
  );
}
